(function () {
  'use strict';

  var MOBILE_QUERY = window.matchMedia('(max-width: 960px)');
  var data = window.jjProductData || {};
  var root = document.querySelector('.jj-lp[data-jjt-pulse-product]');
  if (!root || !Array.isArray(data.variants) || !data.variants.length) return;

  var state = {
    selected: [],
    variant: null,
    gallery: [],
    galleryIndex: 0
  };

  function qa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function make(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function money(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(cents || 0) / 100);
  }

  function optionCount() {
    return Array.isArray(data.optionNames) ? data.optionNames.length : 0;
  }

  function exactVariant(options) {
    return data.variants.find(function (variant) {
      return options.every(function (value, index) {
        return String(variant.options[index]) === String(value);
      });
    }) || null;
  }

  function variantById(id) {
    return data.variants.find(function (variant) {
      return String(variant.id) === String(id);
    }) || null;
  }

  function initialVariant() {
    var params = new URLSearchParams(window.location.search);
    return variantById(params.get('variant')) || variantById(data.currentVariantId) || data.variants[0];
  }

  function buildGallery() {
    var wrap = root.querySelector('#jjGalleryWrap');
    if (!wrap) return;

    wrap.innerHTML = '';
    var gallery = make('div', 'jjt-on-gallery jjt-on-gallery-v3 jjt-on-gallery-final');
    var viewport = make('div', 'jjt-on-gallery-viewport');
    viewport.tabIndex = 0;
    viewport.setAttribute('role', 'region');
    viewport.setAttribute('aria-label', 'Product image gallery');

    var stage = make('div', 'jjt-on-gallery-single');
    var image = make('img', 'jjt-on-gallery-image');
    image.decoding = 'async';
    stage.appendChild(image);
    viewport.appendChild(stage);

    var controls = make('div', 'jjt-on-gallery-controls');
    var previous = make('button', 'jjt-on-gallery-arrow', '←');
    var next = make('button', 'jjt-on-gallery-arrow', '→');
    var count = make('span', 'jjt-on-gallery-count');
    previous.type = 'button';
    next.type = 'button';
    previous.setAttribute('aria-label', 'Previous product image');
    next.setAttribute('aria-label', 'Next product image');
    controls.appendChild(previous);
    controls.appendChild(next);
    controls.appendChild(count);
    gallery.appendChild(viewport);
    gallery.appendChild(controls);
    wrap.appendChild(gallery);

    function update() {
      var images = state.gallery;
      if (!images.length) return;
      state.galleryIndex = Math.max(0, Math.min(state.galleryIndex, images.length - 1));
      image.src = images[state.galleryIndex].src;
      image.alt = images[state.galleryIndex].alt || data.title || 'Pulse product';
      image.loading = state.galleryIndex === 0 ? 'eager' : 'lazy';
      count.textContent = (state.galleryIndex + 1) + ' / ' + images.length;
      previous.disabled = state.galleryIndex === 0;
      next.disabled = state.galleryIndex === images.length - 1;
    }

    previous.addEventListener('click', function () {
      state.galleryIndex -= 1;
      update();
    });
    next.addEventListener('click', function () {
      state.galleryIndex += 1;
      update();
    });
    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        state.galleryIndex -= 1;
        update();
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        state.galleryIndex += 1;
        update();
      }
    });

    var touchX = null;
    viewport.addEventListener('touchstart', function (event) {
      if (event.touches && event.touches.length) touchX = event.touches[0].clientX;
    }, { passive: true });
    viewport.addEventListener('touchend', function (event) {
      if (touchX === null || !event.changedTouches || !event.changedTouches.length) return;
      var distance = event.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(distance) < 45) return;
      state.galleryIndex += distance < 0 ? 1 : -1;
      update();
    }, { passive: true });

    state.updateGallery = update;
    update();
  }

  function setGallery(color) {
    var next = data.galleries && data.galleries[color];
    if (!Array.isArray(next) || !next.length) return;
    state.gallery = next;
    state.galleryIndex = 0;
    if (typeof state.updateGallery === 'function') state.updateGallery();
  }

  function optionGroup(position) {
    return root.querySelector('.jj-pulse-option[data-option-position="' + position + '"]');
  }

  function updateOptionButtons() {
    qa('.jj-pulse-option', root).forEach(function (group) {
      var position = Number(group.dataset.optionPosition) - 1;
      var selectedValue = state.selected[position];
      var current = group.querySelector('.jj-pulse-option-current');
      if (current) current.textContent = ': ' + selectedValue;

      qa('.jj-pulse-option-button[data-option-value]', group).forEach(function (button) {
        var value = button.dataset.optionValue;
        button.classList.toggle('active', value === selectedValue);

        var possible = data.variants.some(function (variant) {
          if (String(variant.options[position]) !== String(value)) return false;
          return state.selected.every(function (selected, index) {
            return index === position || String(variant.options[index]) === String(selected);
          });
        });
        button.classList.toggle('soldout', !possible);
        button.setAttribute('aria-pressed', value === selectedValue ? 'true' : 'false');
      });

      var trigger = group.querySelector('.jjt-on-size-trigger-value');
      if (trigger) trigger.textContent = group.dataset.optionName + ': ' + selectedValue;
    });
  }

  function updatePurchase() {
    var variant = state.variant;
    if (!variant) return;
    root.dataset.selectedVariantId = String(variant.id);

    function syncVariantInput() {
      var input = root.querySelector('#jjVariantInput');
      if (!input || !state.variant) return;
      input.value = String(state.variant.id);
      input.setAttribute('value', String(state.variant.id));
      input.dataset.selectedVariantId = String(state.variant.id);
    }
    syncVariantInput();
    var input = root.querySelector('#jjVariantInput');
    if (input) input.dispatchEvent(new Event('change', { bubbles: true }));
    [0, 120, 450].forEach(function (delay) {
      window.setTimeout(syncVariantInput, delay);
    });

    qa('#jjPrice, [data-jjt-mobile-price]', document).forEach(function (node) {
      node.textContent = money(variant.price);
    });

    var installment = root.querySelector('#jjInstallmentAmount');
    if (installment) installment.textContent = money(variant.price / 4);

    var soldOut = !variant.available;
    var button = root.querySelector('#jjAtcBtn');
    if (button) {
      button.disabled = false;
      button.dataset.notify = soldOut ? 'true' : 'false';
      button.textContent = soldOut ? 'Notify me' : (variant.preorder ? 'Reserve Pulse' : 'Add to bag');
    }
    root.classList.toggle('jjt-selected-sold-out', soldOut);

    var stickyButton = document.querySelector('[data-jjt-mobile-atc]');
    if (stickyButton) {
      stickyButton.dataset.notify = soldOut ? 'true' : 'false';
      stickyButton.textContent = soldOut ? 'Notify me' : (variant.preorder ? 'Reserve Pulse' : 'Add to bag');
    }

    var stickySelect = document.querySelector('[data-jjt-mobile-size-select]');
    if (stickySelect) stickySelect.value = String(variant.id);
  }

  function updateUrl() {
    if (!state.variant) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', state.variant.id);
    history.replaceState({ variant: state.variant.id }, '', url.toString());
  }

  function selectOptions(options, pushUrl) {
    var count = optionCount();
    state.selected = options.slice(0, count);
    state.variant = exactVariant(state.selected);
    if (!state.variant) return;

    updateOptionButtons();
    setGallery(state.selected[0]);
    updatePurchase();
    if (pushUrl) updateUrl();
  }

  function setupSelectors() {
    qa('.jj-pulse-option', root).forEach(function (group) {
      var position = Number(group.dataset.optionPosition) - 1;
      qa('.jj-pulse-option-button[data-option-value]', group).forEach(function (button) {
        button.addEventListener('click', function () {
          var next = state.selected.slice();
          next[position] = button.dataset.optionValue;
          var match = exactVariant(next);
          if (!match) return;
          selectOptions(match.options, true);
        });
      });

      var trigger = group.querySelector('.jjt-on-size-trigger');
      var sizes = group.querySelector('.jj-pulse-sizes');
      if (trigger && sizes) {
        trigger.addEventListener('click', function () {
          var open = !sizes.classList.contains('is-open');
          qa('.jj-pulse-sizes.is-open', root).forEach(function (other) {
            if (other !== sizes) other.classList.remove('is-open');
          });
          sizes.classList.toggle('is-open', open);
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        sizes.addEventListener('click', function (event) {
          if (!event.target.closest('.jjt-on-size-chart-action')) {
            sizes.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
          }
        });
      }

      var chartAction = group.querySelector('.jjt-on-size-chart-action');
      if (chartAction) {
        chartAction.addEventListener('click', function () {
          var details = root.querySelector('.jjt-on-accordion[data-jjt-size-fit]');
          if (!details) return;
          details.open = true;
          var icon = details.querySelector('.jjt-on-accordion-icon');
          if (icon) icon.textContent = '−';
          details.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('.jj-pulse-option')) return;
      qa('.jj-pulse-sizes.is-open', root).forEach(function (sizes) {
        sizes.classList.remove('is-open');
        var trigger = sizes.previousElementSibling;
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function placeResponsive() {
    var grid = root.querySelector('.jj-grid');
    var wrap = root.querySelector('#jjGalleryWrap');
    var info = root.querySelector('.jj-info');
    var gallery = wrap && wrap.querySelector(':scope > .jjt-on-gallery');
    var band = root.querySelector('.jjt-on-detail-band');
    var story = root.querySelector('.jjt-on-story-grid');
    var colors = root.querySelector('.jj-pulse-option[data-option-name="Color"]');
    if (!grid || !wrap || !info || !gallery || !band || !story) return;

    if (MOBILE_QUERY.matches) {
      var rail = root.querySelector('.jjt-on-mobile-color-rail');
      if (!rail && colors) {
        rail = make('section', 'jjt-on-mobile-color-rail');
        rail.setAttribute('aria-label', 'Pulse colorways');
        wrap.insertAdjacentElement('afterend', rail);
      }
      if (rail && colors && colors.parentNode !== rail) rail.appendChild(colors);
      if (band.parentNode !== root || grid.nextElementSibling !== band) grid.insertAdjacentElement('afterend', band);
      story.classList.remove('jjt-on-story-grid--full');
      if (story.parentNode !== band) band.appendChild(story);
      var breadcrumbs = root.querySelector('.jjt-on-breadcrumbs');
      if (breadcrumbs) breadcrumbs.hidden = true;
    } else {
      var mobileRail = root.querySelector('.jjt-on-mobile-color-rail');
      var form = info.querySelector('.jj-product-form');
      if (colors && form && colors.parentNode !== info) info.insertBefore(colors, form);
      if (mobileRail) mobileRail.remove();
      if (band.parentNode !== wrap || gallery.nextElementSibling !== band) gallery.insertAdjacentElement('afterend', band);
      story.classList.add('jjt-on-story-grid--full');
      if (story.parentNode !== root || grid.nextElementSibling !== story) grid.insertAdjacentElement('afterend', story);
      var desktopBreadcrumbs = root.querySelector('.jjt-on-breadcrumbs');
      if (desktopBreadcrumbs) desktopBreadcrumbs.hidden = false;
    }
  }

  function setupAccordions() {
    qa('.jjt-on-accordion', root).forEach(function (details) {
      details.addEventListener('toggle', function () {
        var icon = details.querySelector('.jjt-on-accordion-icon');
        if (icon) icon.textContent = details.open ? '−' : '+';
      });
    });
  }

  function setupMobileSticky() {
    var sticky = document.querySelector('[data-jjt-mobile-sticky]');
    var select = sticky && sticky.querySelector('[data-jjt-mobile-size-select]');
    var button = sticky && sticky.querySelector('[data-jjt-mobile-atc]');
    var mainButton = root.querySelector('#jjAtcBtn');
    if (!sticky || !select || !button || !mainButton) return;

    select.innerHTML = data.variants.map(function (variant) {
      return '<option value="' + variant.id + '">' + variant.title + (variant.available ? '' : ' / Notify me') + '</option>';
    }).join('');

    select.addEventListener('change', function () {
      var variant = variantById(select.value);
      if (variant) selectOptions(variant.options, true);
    });
    button.addEventListener('click', function () {
      if (button.dataset.notify === 'true') openBis();
      else mainButton.click();
    });

    function visibility() {
      var show = MOBILE_QUERY.matches;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    visibility();
    MOBILE_QUERY.addEventListener('change', visibility);
  }

  function openBis() {
    var modal = document.querySelector('[data-jjt-bis-modal]');
    if (!modal || !state.variant) return;
    modal.dataset.variantId = state.variant.id;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    var email = modal.querySelector('input[type="email"]');
    if (email) window.setTimeout(function () { email.focus(); }, 50);
  }

  function setupBis() {
    var modal = document.querySelector('[data-jjt-bis-modal]');
    var form = modal && modal.querySelector('[data-jjt-bis-form]');
    if (!modal || !form) return;

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    }
    qa('[data-jjt-bis-close]', modal).forEach(function (button) {
      button.addEventListener('click', close);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = form.querySelector('input[type="email"]');
      var status = form.querySelector('[data-jjt-bis-status]');
      if (!email || !email.validity.valid || !state.variant) return;
      status.textContent = 'Submitting…';
      var body = new URLSearchParams({ a: 'S5XVBX', email: email.value.trim(), variant: state.variant.id, platform: 'shopify' });
      fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      }).then(function () {
        status.textContent = 'You’re on the list. We’ll email you when it’s back.';
        form.reset();
      }).catch(function () {
        status.textContent = 'Please try again in a moment.';
      });
    });
  }

  function setupCart() {
    var form = root.querySelector('#jjProductForm');
    var button = root.querySelector('#jjAtcBtn');
    if (!form || !button) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!state.variant) return;
      if (!state.variant.available || button.dataset.notify === 'true') {
        openBis();
        return;
      }

      var label = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(state.variant.id), quantity: 1 }] })
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to add selected variant');
        return response.json();
      }).then(function (payload) {
        var item = payload && payload.items ? payload.items[payload.items.length - 1] : payload;
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { item: item } }));
        if (window.JJTBagToast && typeof window.JJTBagToast.show === 'function') window.JJTBagToast.show(item);
      }).catch(function () {
        button.textContent = 'Please try again';
        window.setTimeout(function () { button.textContent = label; }, 1600);
      }).finally(function () {
        button.disabled = false;
        if (button.textContent === 'Adding…') button.textContent = label;
      });
    });
  }

  function wireChrome() {
    var search = document.querySelector('[data-jjt-on-search]');
    var cart = document.querySelector('[data-jjt-on-cart]');
    var menu = document.querySelector('[data-jjt-mobile-product-menu]');
    if (search) search.addEventListener('click', function () {
      var original = document.querySelector('.js-search-header');
      if (original) original.click();
    });
    if (cart) cart.addEventListener('click', function () {
      var original = document.querySelector('.js-drawer-open-cart, [aria-controls="CartDrawer"]');
      if (original) original.click();
    });
    if (menu) menu.addEventListener('click', function () {
      var original = document.querySelector('[data-jjt-dock-menu], .js-drawer-open-nav, [aria-controls="NavDrawer"], [data-drawer-open="nav"]');
      if (original) original.click();
    });

    var mega = document.querySelector('[data-jjt-mega]');
    var backdrop = document.querySelector('[data-jjt-mega-backdrop]');
    if (!mega || !backdrop) return;
    function close() {
      mega.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      qa('[data-jjt-mega-trigger]').forEach(function (trigger) { trigger.setAttribute('aria-expanded', 'false'); });
      qa('[data-jjt-mega-panel]', mega).forEach(function (panel) { panel.classList.remove('is-active'); });
    }
    qa('[data-jjt-mega-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var key = trigger.dataset.jjtMegaTrigger;
        qa('[data-jjt-mega-panel]', mega).forEach(function (panel) {
          panel.classList.toggle('is-active', panel.dataset.jjtMegaPanel === key);
        });
        mega.classList.add('is-open');
        backdrop.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      });
    });
    backdrop.addEventListener('click', close);
    qa('[data-jjt-mega-close]', mega).forEach(function (button) { button.addEventListener('click', close); });
  }

  function init() {
    var first = initialVariant();
    state.gallery = (data.galleries && data.galleries[first.options[0]]) || [];
    buildGallery();
    setupSelectors();
    setupAccordions();
    setupMobileSticky();
    setupBis();
    setupCart();
    wireChrome();
    selectOptions(first.options, false);
    placeResponsive();
    MOBILE_QUERY.addEventListener('change', placeResponsive);
    window.addEventListener('resize', placeResponsive);
    window.addEventListener('popstate', function () {
      var variant = initialVariant();
      selectOptions(variant.options, false);
    });
  }

  init();
})();
